import { MidpointRoundingType } from './midpoint';

const roundFixedPoint = (value, nearest = 1, midpoint = MidpointRoundingType.ToEven) => {
  if (midpoint === MidpointRoundingType.AwayFromZero) return roundAwayFromZero(value, nearest);
  else return roundToEven(value, nearest);
};

const roundAwayFromZero = (value, nearest) => {
  let result;

  // JS by default rounds toward +infinity, so we make it round away from zero for consistency with the backend
  if (value < 0) result = -Math.round(-value / nearest);
  else result = Math.round(value / nearest);

  return +(result * nearest).toFixed(8); // Avoid rounding errors
};

// Adapted from https://stackoverflow.com/a/3109234
const roundToEven = (value, nearest) => {
  const number = +(value / nearest).toFixed(8); // Avoid rounding errors

  const floored = Math.floor(number);
  const delta = number - floored;
  const error = 1e-8; // Allow for rounding errors in float

  let result;

  if (delta > 0.5 - error && delta < 0.5 + error) {
    result = floored % 2 === 0 ? floored : floored + 1;
  } else {
    result = Math.round(number);
  }

  return +(result * nearest).toFixed(8); // Avoid rounding errors
};

export default roundFixedPoint;
